function getSanitizedSingleTicker(rawTicker: string) {
  return rawTicker
    .replace(/\.+/gi, '-')
    .split('-')
    .map((x) => x.replace(/([^a-z0-9@-])+/gi, ''))
    .filter((x) => !!x)
    .join('-')
    .toUpperCase()
}

export function getSanitizedTicker(rawTicker: string, isMulti = false) {
  if (isMulti) {
    return rawTicker
      .replace(/ /g, ',')
      .split(',')
      .map(getSanitizedSingleTicker)
      .filter((x) => !!x)
      .join(',')
  }

  return getSanitizedSingleTicker(rawTicker)
}
